import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

import Button from '../../../components/Button/Button';
import DateContainer from '../../../components/DateContainer/DateContainer';
import Panel from '../../../components/Panel/Panel';

import {
  ClockIcon,
  PencilSolidIcon,
  TrashSolidIcon,
} from '../../../images/shapes';

const ContentObjectPublicationSchedule = ({
  publishedAt,
  onEdit,
  onDelete,
  isPinned,
  additionalClasses,
  testId,
}) => {
  const { t } = useTranslation();

  if (!publishedAt) return;

  return (
    <Panel
      title={t('PublicationSchedule.Title')}
      isCollapsable={false}
      additionalContainerClasses={twMerge('px-4', additionalClasses)}
      additionalTitleClasses="text-lg"
      additionalChildrenClasses={'pt-2'}
      open
    >
      <div className="flex gap-2">
        <DateContainer
          icon={
            <ClockIcon
              className={twMerge('w-[18px] mr-3', isPinned && 'xl:!mr-0')}
            />
          }
          date={publishedAt}
          isCompact={isPinned}
          isBold={false}
          dateFormat="ddd, LL LT"
          additionalClasses="truncate"
          {...getTestProps(testId, 'published-at', 'testId')}
        />

        <Button
          buttonColor="blueBordered"
          buttonSize="xs"
          iconImage={<PencilSolidIcon className="w-4 group-hover:text-white" />}
          additionalClasses="shrink-0 bg-transparent ml-auto"
          onClick={onEdit}
          {...getTestProps(testId, 'edit', 'testId')}
        />

        <Button
          buttonColor="blueBordered"
          buttonSize="xs"
          iconImage={<TrashSolidIcon className="w-4 group-hover:text-white" />}
          additionalClasses="shrink-0 bg-transparent"
          onClick={onDelete}
          {...getTestProps(testId, 'delete', 'testId')}
        />
      </div>
    </Panel>
  );
};
export default ContentObjectPublicationSchedule;
